import { graphql } from '@prophecy/graphql-types/graphql';
import { userGitCredsQuery } from '../common/git/GitIntegration/queries';
import { getUserFabricFields } from '../data/apis/getUserFabricFields';
export const checkEmailIdExists = graphql(`
  query checkEmailIdExists($emailIDs: [String!]!) {
    ifEmailExists(emailIds: $emailIDs) {
      email
      exists
      invitationStatus
    }
  }
`);
export function getUserQuery(isSqlProject, hasAirflow) {
    return graphql(`
    query UserFabricQuery($id: String!) {
      User(uid: $id) {
        _id
        attributes
        firstName
        lastName
        company
        created
        email
        copilotEnabled
        teams {
          _id
          name
        }
        gitSavedCreds {
          ${userGitCredsQuery}
        }
        aspects(aspect: [Info]) {
          AspectName
          AspectValue
        }
        fabrics {
          ${getUserFabricFields(isSqlProject, hasAirflow)}
        }
        SqlFabricCredsInfoAspect: aspects(aspect: SqlFabricCredsInfo) {
          AspectValue
          AspectName
        }
      }
    }
  `);
}
export const teamGitCredsQuery = graphql(`
  query TeamGitCredsQuery($teamUID: String) {
    TeamGitCreds(teamUID: $teamUID) {
      
        ${userGitCredsQuery}
      
    }
  }
`);
